export { MyBestieLanding } from './MyBestieLanding';
